/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import { Fixed } from 'particles'
/* --------------------------- Styled Component ----------------------------- */
export default props => <Fixed {...props} />


// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Fixed/index.js